import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'provideErrorMsg',
})

export class ProvideErrorMessagePipe implements PipeTransform {
    transform( errorMsg: any, operatorErrors:any):any {
        if(operatorErrors){
            const errorarr = Object.keys(operatorErrors)
            for(let i=0; i< errorarr.length; i++){
                if(errorMsg[errorarr[i]]){
                    return errorMsg[errorarr[i]]
                }
            }
        }
        return null;
    }
}